module.exports = "<div id=\"tbStOffElMenuRoot\">\n    <div \n        kendo-tree-view=\"tbStOffElMenu\" \n        k-options=\"tbStOffElMenuCtrl.tbSubscriptionTreeOptions\"\n        k-on-check=\"tbStOffElMenuCtrl.handleMenuItemCheck(kendoEvent)\"\n        k-on-change=\"tbStOffElMenuCtrl.handleMenuItemChange(data, dataItem, kendoEvent)\"\n        k-rebind=\"tbStOffElMenuCtrl.initComplete\">\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directives/StateOfficeElectionMenu/StateOfficeElectionMenu.tpl.html
// module id = 6Ywx
// module chunks = 1